export class Component {
    constructor( context ) {
        this.context = context;
        this.settings = {
            priority: 0,
            methods: {
                _setup: this.setup ? this.setup.bind( this ) : null,
                _resize: this.resize ? this.resize.bind( this ) : null,
                _scroll: this.scroll ? this.scroll.bind( this ) : null,
                _load: this.load ? this.load.bind( this ) : null,
                _raf: this.raf ? this.raf.bind( this ) : null,
            },
        };

        this.baseURL = context.Settings.home_url;
        this.uiSettings = context.Settings;
        this.setup = false;
        this.resize = false;
        this.scroll = false;
        this.load = false;
        this.raf = false;
    }

    // mountComponent() {
    //     this.context.mountComponent( this, this.getNamespace(), this.settings );
    // }

    getNamespace() {
        const priority = this.settings.priority;

        // Unique for each component
        return 'c-ns-' + String( priority + Math.random() ).replace( /\D/g, '' );

        // if ( ! this.constructor || !this.constructor.name ) {
        //     return ns;
        // }

        // console.log(this.constructor, 'this');

        // return this.constructor.name;
    }
}
